import { useLocation, useNavigate } from 'react-router-dom'
import Empty from '@/components/ui/Empty/Empty'
import Button from '@/components/ui/Button/Button'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { logoutSaga } from '@/store/auth/authSlice'
import { sanitizeNext } from '@/store/auth/workspaceEntry'
import css from './WorkspaceNoAccessPage.module.css'

// Shown (SCD-934, scenarios 3+5) when a signed-in user opens a link to a workspace they're not
// a member of. A standalone screen — not a silent bounce to their own dashboard — so they can
// see who they're signed in as and switch accounts, with the original link preserved.
const WorkspaceNoAccessPage = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const email = useAppSelector(state => state.auth?.email)

    const next = sanitizeNext(new URLSearchParams(location.search).get('next'))

    const handleSwitchAccount = () => {
        // Remember the link so re-signing in lands on it (loadUserData consumes authNext).
        try { sessionStorage.setItem('authNext', next) } catch { /* ignore */ }
        dispatch(logoutSaga())
    }

    const handleGoToMine = () => {
        navigate('/', { replace: true })
    }

    return (
        <Empty
            title="You don't have access"
            text="This workspace is private. Ask an admin to invite you, or sign in with an account that has access."
            button={
                <div className={css.actions}>
                    {email && <div className={css.who}>Signed in as <b>{email}</b></div>}
                    <Button title="Sign in with another account" type="black" size="medium" onClick={handleSwitchAccount} testId="no-access-switch-account" />
                    <Button title="Go to my workspace" type="white" size="medium" onClick={handleGoToMine} />
                </div>
            }
        />
    )
}

export default WorkspaceNoAccessPage
